import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.match.js';

class TextNewlineLengthUseCase {
  execute(text) {
    // when user type \n we need add more 150 caracteres
    const newLineCount = (text.match(/\n/g) || []).length * 100;
    return newLineCount + text.length;
  }
}

export { TextNewlineLengthUseCase };
